import { render, staticRenderFns } from "./PagePopup.vue?vue&type=template&id=6712d14b&scoped=true&lang=pug&"
import script from "./PagePopup.vue?vue&type=script&lang=ts&"
export * from "./PagePopup.vue?vue&type=script&lang=ts&"
import style0 from "./PagePopup.vue?vue&type=style&index=0&id=6712d14b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6712d14b",
  null
  
)

export default component.exports